import React from 'react';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles( theme => ({
    gob:{
        height: "5px"
    },
    barraAzul:{
        display: "block",
        marginLeft: "0px",
        paddingLeft: "0px",
        float: "left",
        height: "100%",
        background: "#0f69b4",
        width: "46%"
    },
    barraRojo:{
        display: "block",
        marginRight: "0px",
        paddingRight: "0px",
        float: "right",
        height: "100%",
        background:" #eb3646",
        width: "54%"
    }
}));


const HeaderBand = () => {
    const classes = useStyles();
    return (
        <div className={classes.gob + " px-0 mx-0 w-100 mb-1"}>
            <div className={classes.barraAzul + " pr-0 mr-0"}/>
            <div className={classes.barraRojo + " pl-0 ml-0"}/>
        </div>
    );
};

export default HeaderBand;